<script setup lang="ts">
import { Link } from "@inertiajs/vue3"
import { SettingsIcon } from "lucide-vue-next"
import { computed } from "vue"

import { settingsProfilePath } from "@/routes"

interface Props {
  title: string
  description?: string
  name?: string
}

const props = defineProps<Props>()

const initials = computed(() => {
  if (!props.name) return ""
  const names = props.name.split(" ")
  return names.map((n) => n[0]).join("")
})
</script>

<template>
  <div class="space-y-2">
    <h2 class="text-primary text-4xl tracking-tight">
      {{ title }}
    </h2>
    <div v-if="name" class="flex items-center gap-2 text-3xl">
      <div
        class="bg-muted relative inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-full text-base"
      >
        <img src="https://i.pravatar.cc/300" alt="Profile Image" />
      </div>
      {{ name }}!
    </div>
    <Link
      :href="settingsProfilePath()"
      class="text-primary border-primary flex w-fit items-center gap-2 rounded-sm border bg-[#F4F4FF] px-2 py-1 text-sm"
    >
      <SettingsIcon class="size-4" />
      Gestiona tu información personal
    </Link>
  </div>
</template>
